import styled from "styled-components";
import { Grid } from "../../styles/global.syles";

export const PlansContent = styled.div`
	@media screen and (max-width: 1024px) {
		${Grid} {
			grid-template-columns: repeat(2, 1fr);
			gap: 20px;
		}
	}

	@media screen and (max-width: 580px) {
		${Grid} {
			grid-template-columns: 1fr;
			gap: 20px;
		}
	}
`;
